import type React from "react";

export type ButtonProps = {
	onClickHandler: () => void;
	name?: string;
	icon?: React.ReactNode;
	disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
	onClickHandler,
	name,
	icon,
	disabled,
}) => {
	return (
		<button
			type="button"
			disabled={disabled}
			className="blur-btn"
			onClick={onClickHandler}
		>
			{icon && icon}
			{name && <span>{name}</span>}
		</button>
	);
};

export default Button;
